import ProtectedByRecaptcha from "@casino/legacy/client/components/Auth/ProtectedByRecaptcha";
import Stack from "@casino/legacy/client/shared/Stack";
import AlreadyHaveAccountLink from "./AlreadyHaveAccountLink";
import LanguageSwitcher from "./LanguageSwitcher";
import TermsAndPolicyLinks from "./TermsAndPolicyLinks";

type Props = {
  isPopover?: boolean;
  isLanguageSwitcherHidden?: boolean;
};

const RegisterBottomLinks: FC<Props> = ({
  isPopover,
  isLanguageSwitcherHidden,
}) => (
  <>
    <Stack space="small" alignContent="start">
      <TermsAndPolicyLinks />
      <AlreadyHaveAccountLink isPopover={isPopover} />
      <ProtectedByRecaptcha />
    </Stack>
    {!isPopover && !isLanguageSwitcherHidden && (
      <div className="-mt-9 flex w-1/2 justify-center">
        <LanguageSwitcher optionClassName="block !p-0" />
      </div>
    )}
  </>
);

export default RegisterBottomLinks;
